import { render, staticRenderFns } from "./sporttype.vue?vue&type=template&id=9d9f232c"
import script from "./sporttype.vue?vue&type=script&lang=js"
export * from "./sporttype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports